<template>
  <div>
    <div v-if="$vuetify.breakpoint.xlOnly">
      <table>
        <tbody>
          <tr class="tbl-labels-row">
            <td v-for="item in creneauMorn" :key="item.id">
              {{ item }}
            </td>
          </tr>
        </tbody>
      </table>
      <table class="tbl-blocks">
        <tbody>
          <tr class="tbl-blocks-row">
            <td
              v-for="index in creneauMorn.length - 1"
              :key="index"
              :class="classNameForTimeSlot(index - 1)"
            ></td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr class="tbl-labels-row">
            <td v-for="item in creneauAfter" :key="item.id">
              {{ item }}
            </td>
          </tr>
        </tbody>
      </table>
      <table class="tbl-blocks">
        <tbody>
          <tr class="tbl-blocks-row">
            <td
              v-for="index in creneauAfter.length - 1"
              :key="index"
              :class="classNameForTimeSlot(index - 1 + 9)"
            ></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <table>
        <tbody>
          <tr class="tbl-labels-row2">
            <td v-for="item in creneauMorn" :key="item.id">
              {{ item }}
            </td>
          </tr>
        </tbody>
      </table>
      <table class="tbl-blocks">
        <tbody>
          <tr class="tbl-blocks-row2">
            <td
              v-for="index in creneauMorn.length - 1"
              :key="index"
              :class="classNameForTimeSlot(index - 1)"
            ></td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr class="tbl-labels-row2">
            <td v-for="item in creneauAfter" :key="item.id">
              {{ item }}
            </td>
          </tr>
        </tbody>
      </table>
      <table class="tbl-blocks">
        <tbody>
          <tr class="tbl-blocks-row2">
            <td
              v-for="index in creneauAfter.length - 1"
              :key="index"
              :class="classNameForTimeSlot(index - 1 + 9)"
            ></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import { mapGetters } from "vuex";

export default {
  name: "TimeGrid",
  props: {
    room: null,
  },
  data() {
    return {
      creneauMorn: [
        "9h00",
        "9h30",
        "10h00",
        "10h30",
        "11h00",
        "11h30",
        "12h00",
        "12h30",
        "13h00",
        "13h30",
      ],
      creneauAfter: [
        "13h30",
        "14h00",
        "14h30",
        "15h00",
        "15h30",
        "16h00",
        "16h30",
        "17h00",
        "17h30",
        "18h00",
      ],
    };
  },
  computed: {
    ...mapGetters("bookingModule", {
      bookings: "getBookings",
      hasRoomBookingsOnDay: "hasRoomBookingsOnDay",
      getRoomBookingsByTimeSlots: "getRoomBookingsByTimeSlots",
    }),
    ...mapGetters("deskModule", {
      availableDesksByRoom: "getAvailableDesksByRoom",
    }),
  },
  methods: {
    roomBookingsByTimeSlots() {
      return this.getRoomBookingsByTimeSlots(this.room, DateTime.now());
    },
    availableDesks() {
      return this.availableDesksByRoom(this.room);
    },
    classNameForTimeSlot(index) {
      // no bookings
      if (!this.bookings.length) return "tbl-blk-green";
      const roomBookings = this.roomBookingsByTimeSlots();
      // no bookings for this room
      if (!roomBookings) return "tbl-blk-green";
      const numAvailDesks = this.availableDesks().length;
      const slot = roomBookings.slots[index];

      // the room has no desks but has a booking on this time slot
      if ((numAvailDesks === 0 && slot.any) || slot.whole) return "tbl-blk-red";
      // the room is free
      else if (slot.desks.size === 0) return "tbl-blk-green";
      // some desks are booked
      else
        return slot.desks.size < numAvailDesks
          ? "tbl-blk-orange"
          : "tbl-blk-red";
    },
  },
};
</script>

<style lang="scss">
.tbl-labels-row > td {
  text-align: left;
  width: 80px;
}
.tbl-labels-row2 > td {
  text-align: center;
  min-width: 60px;
  width: 60px;
}

.tbl-blocks {
  padding-left: 1.5em;
}

.tbl-blocks-row > td {
  min-width: 80px;
  width: 60px;
  min-height: 15px;
  height: 15px;
}
.tbl-blocks-row2 > td {
  min-width: 60px;
  width: 60px;
  min-height: 15px;
  height: 15px;
}

.tbl-blk-green {
  background-color: green;
}

.tbl-blk-red {
  background-color: red;
}

.tbl-blk-orange {
  background-color: orange;
}
</style>
